module.exports = __webpack_public_path__ + "home/img/list.fb7764f5.svg";